/**
 * Public standalone URL for the INVERT advertising agreement.
 * @param {number|string|null|undefined} amountUsd
 * @param {{ screenCount?: number, selectedScreenIds?: number[], fleetSize?: number }} [options]
 * @returns {string}
 */
export function platformAgreementPath(amountUsd, options = {}) {
    const params = new URLSearchParams();
    if (amountUsd != null && amountUsd !== '' && Number.isFinite(Number(amountUsd))) {
        params.set('amountUsd', String(Number(amountUsd)));
    }
    const screenCount = Math.floor(Number(options.screenCount) || 0);
    if (screenCount > 0) {
        params.set('screenCount', String(screenCount));
    }
    const ids = (options.selectedScreenIds || [])
        .map((id) => parseInt(id, 10))
        .filter((id) => Number.isFinite(id) && id > 0);
    if (ids.length > 0) {
        params.set('screenIds', ids.join(','));
    }
    const fleetSize = Math.floor(Number(options.fleetSize) || 0);
    if (fleetSize > 0) {
        params.set('fleetSize', String(fleetSize));
    }
    const qs = params.toString();
    return qs ? `/advertiser-advertising-agreement?${qs}` : '/advertiser-advertising-agreement';
}
